import { render, staticRenderFns } from "./Spectroscope.vue?vue&type=template&id=4e754f7c&"
import script from "./Spectroscope.vue?vue&type=script&lang=js&"
export * from "./Spectroscope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports